export default __webpack_public_path__ + "static/media/auto-restrito.5d7d90da.png";